import { yupResolver } from '@hookform/resolvers/yup';
import { AxiosError } from 'axios';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { DataFileEntity, DataFileForm } from 'v2/DataFiles/models';
import restFactory from 'v2/utils/restFactory';
import * as yup from 'yup';

const FILE_TYPES: DataFileEntity['file_type'][] = [
  'Data_Dictionary',
  'Product_Overview',
  'Company_Overview',
  'Sample_Data',
  'Whitepaper',
  'Other',
];

const schema = yup.object().shape({
  description: yup.string().required('Required'),
  file_type: yup.mixed().oneOf(FILE_TYPES, 'Required').required('Required'),
  name: yup
    .string()
    .required('Required')
    .max(64, 'Must be less that 64 characters.'),
});

export const DATA_PRODUCT_DEFAULT_VALUES: Partial<DataFileForm> = {
  description: '',
  file_type: undefined,
  name: '',
};

function useDatFileForm(
  selectedFile: File | null,
  data: DataFileEntity | null | undefined
) {
  const [isLoading, setIsLoading] = useState(false);
  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useForm<DataFileForm>({
    defaultValues: data
      ? {
          description: data.description,
          file_type: data.file_type,
          name: data.name,
        }
      : DATA_PRODUCT_DEFAULT_VALUES,
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  const onSubmit = async (
    formData: DataFileForm
  ): Promise<DataFileEntity | null> => {
    try {
      setIsLoading(true);
      const response = await saveDataFile(
        {
          ...formData,
          id: data?.id || 0,
        },
        selectedFile
      );
      setIsLoading(false);
      return response;
    } catch (error) {
      toast.error((error as AxiosError).message);
      setIsLoading(false);
      return null;
    }
  };

  return { handleSubmit, register, errors, onSubmit, isLoading, reset };
}

export default useDatFileForm;

async function saveDataFile(
  data: DataFileForm,
  selectedFile: File | null
): Promise<DataFileEntity> {
  const bodyFormData = new FormData();

  for (const [key, value] of Object.entries(data)) {
    bodyFormData.append(key, value);
  }
  if (selectedFile) {
    bodyFormData.append('file', selectedFile);
  }
  return await restFactory[data.id ? 'put' : 'post'](
    `data-files${data.id ? `/${data.id}` : ''}`,
    bodyFormData,
    { 'Content-Type': 'multipart/form-data' }
  );
}
